import {Injectable, OnDestroy, OnInit} from '@angular/core';
import {BaseCommon} from "../base-common";

@Injectable({
    providedIn: 'root'
})
// export class BaseForm<T> extends BaseCommon implements OnInit,OnDestroy {
export class BaseForm<T> extends BaseCommon implements OnInit,OnDestroy {

    pathList: String = '';

    constructor(protected dataPath: string) {
        super();
        this.pathList = this.dataPath;
    }

    ngOnDestroy(): void {
    }

    ngOnInit(): void {
    }

    initForm() {

    }

    mapToData(map: any): any {
    }

    formDataToMap() {
    }

    onBack() {
    }

    saveNewData(value: T) {
    }

    updateData(value: T) {
    }

    onSaveData() {
    }

}
